<template>
  <div>Hello from Store</div>
</template>

<script>
export default {
  name: "Store"
};
</script>

<style lang="scss" scoped>
</style>